import React, { useEffect, useState, useRef } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { Form } from 'antd'
import { IoAddCircleOutline, IoRemoveCircle, IoAccessibility } from 'react-icons/io5'

import RoleTable from './components/RoleTable'

import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import DataTable from 'Shared/Components/DataTable'
import PopupModal from 'Shared/Components/PopupModal'
import { TextInput, FormContainer } from 'Shared/Components/FormComponents'
import { showSuccess } from 'Shared/Components/NotifyToast'

const Users = () => {
  const { setPageLoading } = useOutletContext()
  
  const { t } = useTranslation()
  const { send } = useFetchData()
  const [form] = Form.useForm()

  const [users, setUsers] = useState([])
  const [modalOpen, setModalOpen] = useState({
    "isOpen": false,
    "mode": null
  })
  const [roleModalOpen, setRoleModalOpen] = useState({
    "isOpen": false,
    "user_id": null
  })

  const tableRef = useRef()

  const filterRef = useRef({
    "search": ""
  })

  const loadData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/user/users`,
      params: {
        "offset": (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
        "limit": tableRef.current.getState()["itemsPerPage"],
        "search": filterRef.current.search,
      },
      returnType: "json"
    })

    body && setUsers({
      "data": body["data"].map((i) => ({
        "user_id": i["user_id"],
        "username": i["username"],
        "email": i["email"]
      })),
      "count": Math.ceil(body["count"]/tableRef.current.getState()["itemsPerPage"])
    })
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await loadData()

      setPageLoading(false)
    }

    init()
  }, [])

  const onFinish = async (values) => {
    setPageLoading(true)

    let method = null

    switch (modalOpen["mode"]) {
      case "Add":
        method = "POST"
        break
      case "Edit":
        method = "PUT"
        break
      case "Delete":
        method = "DELETE"
        break
    }

    const res = await send({
      url: `${apiUrl}/user/orginization_member`,
      method: method,
      contentType: "json",
      body: {
        "email": values["email"],
      }
    })

    if (res != null) {
      toggleForm()
      
      showSuccess(t("general_success"))

      tableRef.current.setTableLoading(true)

      await loadData()

      tableRef.current.setTableLoading(false)
    }

    setPageLoading(false)
  }

  const toggleForm = (user, mode) => {
    if (modalOpen["isOpen"]) {
      form.resetFields()
    }

    if (user) {
      form.setFieldsValue({
        "email": user["email"]
      })
    }

    setModalOpen({
      "isOpen": !modalOpen["isOpen"],
      "mode": mode
    })
  }

  const onSearch = async (value, _e, info) => {    
    filterRef.current.search = value

    tableRef.current.setTableLoading(true)

    await loadData()

    tableRef.current.setTableLoading(false)
  }

  const reload = async () => {
    tableRef.current.setTableLoading(true)

    await loadData()

    tableRef.current.setTableLoading(false)
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={users["data"]} count={users["count"]} ref={tableRef} onSearch={onSearch} loadData={reload}
              columns={{
                "username": { "label": t("users_username"), "sorting": false, "nowrap": true },
                "email": { "label": t("users_email"), "sorting": false, "nowrap": true },
              }}
              appActions={() => { return [
                {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { toggleForm(null, "Add") }}
              ]}}
              renderActions={(row) => { return [
                {icon: <IoAccessibility size={20}/>, text: t("users_roles"), onClick: function(row) { setRoleModalOpen({ "isOpen": true, "user_id": row }) }},
                {icon: <IoRemoveCircle size={20}/>, text: t("general_remove"), onClick: function(row) { toggleForm(row, "Delete") }},
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container>

    <PopupModal isOpen={modalOpen["isOpen"]} maxHeight="50%" width="70%" close toggle={toggleForm}>
      <FormContainer form={form} onFinish={onFinish} initialValues={{}}>
        <TextInput field_name={t("users_email")} field_id="email" required disabled={modalOpen["mode"] != "Add"}/>        
      </FormContainer>
    </PopupModal>

    <PopupModal isOpen={roleModalOpen["isOpen"]} maxHeight="50%" width="70%" close toggle={() => setRoleModalOpen(false)}>
      <RoleTable user={roleModalOpen["user_id"]}/>
    </PopupModal>
  </>)
}

export default Users
